module.exports = __webpack_public_path__ + "img/logo-slim.c25e263b.png";